if( sessionStorage.stock_tab ) {
	$('#' + sessionStorage.stock_tab).tab('show');
}
else {
	$('#stock a[data-toggle="pill"]:eq(0)').tab('show');
}

$('#stock a[data-toggle="pill"]').on('show.bs.tab', function(e) {
	sessionStorage.setItem('stock_tab', $(e.target).attr('id'));
});

// bouton stock : on ajoute l'état sélectionné dans l'url du formulaire d'export
$('#stock #btn_export').on('click', function() {
	var $this = $(this);
	$('#frm_export').attr('action', $this.data('url'));
	$('#frm_export [name="action"]').val('export');
});

// bouton stock livraison on change l'url et l'action 
$('#btn_export_livraisons').on('click', function() {
	var $this = $(this);
	$('#frm_export').attr('action', $this.data('url'));
	$('#frm_export [name="action"]').val('exportlivraisons');
});